import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
  EventEmitter,
  Output,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { EngagementService } from '../../../../../../services/engagement.service';
import { ClientService } from '../../../../../../services/client.service';
import { GridModule } from '@progress/kendo-angular-grid';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { InputsModule, SliderModule } from '@progress/kendo-angular-inputs';
import {
  KENDO_LAYOUT,
  LayoutModule,
} from '@progress/kendo-angular-layout';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import {
  KENDO_ICONS,
  IconsModule,
  SVGIcon,
} from '@progress/kendo-angular-icons';
import { KENDO_BUTTONS, ButtonsModule } from '@progress/kendo-angular-buttons';
import { LabelModule } from '@progress/kendo-angular-label';
import {
  AutoCompleteComponent,
  DropDownsModule,
} from '@progress/kendo-angular-dropdowns';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { IntlModule } from '@progress/kendo-angular-intl';
import { PopupService, PopupRef } from '@progress/kendo-angular-popup';
import { searchIcon, caretAltDownIcon } from '@progress/kendo-svg-icons';

import { Input } from '@angular/core';
import {
  PopupModule,
  Align,
  AnimationDirection,
  AnimationType,
  PopupAnimation,
} from '@progress/kendo-angular-popup';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ShownotificationService } from '../../../../../../services/shownotification.service';
import { AuthService } from '../../../../../../shared/auth/auth.service';
import { UserService } from '../../../../../../services/user.service';
import { SaveUserRequestDetailRequest } from '../../../../../../models/request/engagement-user-request/saveUserRequestDetailRequest.model';
import { UserrequestService } from '../../../../../../services/userrequest.service';
import { UserRequestRoleType } from '../../../../../../models/userRequestRoleType';
import { AuthUserService } from '../../../../../../shared/auth/auth-user.service';
import { Roles } from '../../../../../../constants/roles';
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { Subject } from 'rxjs/internal/Subject';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-useraddrequest',
  standalone: true,
  templateUrl: './useraddrequest.component.html',
  styleUrl: './useraddrequest.component.scss',
  imports: [
    KENDO_LAYOUT,
    KENDO_ICONS,
    KENDO_BUTTONS,
    KENDO_INDICATORS,
    GridModule,
    ChartsModule,
    InputsModule,
    SliderModule,
    LayoutModule,
    ScrollViewModule,
    IconsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    ListViewModule,
    FormsModule,
    ReactiveFormsModule,
    GaugesModule,
    IntlModule,
    PopupModule,
    NgxSpinnerModule
],
})
export class UserAddRequestComponent {
  @Input() openUserRequestPopup!: boolean;
  @Input() isEngagementAccessRequired!: boolean;
  @Input() anchor!: any;
  @Output() closeEvent = new EventEmitter<void>();

  @ViewChild('popupContent') popupContent!: TemplateRef<any>;

  private popupRef: PopupRef | undefined;

  @ViewChild('autocomplete', { static: false })
  public autocomplete!: AutoCompleteComponent;

  public searchIcon: SVGIcon = searchIcon;
  public caretAltDownIcon: SVGIcon = caretAltDownIcon;

  public userRequestDetailsForm!: FormGroup;
  public enabled = true;
  public duration = 200;
  public DEBOUNCE_TIME = 500; // Debounce time in milliseconds
  public type: AnimationType = 'slide';
  public direction: AnimationDirection = 'left';
  public margin = { horizontal: -100, vertical: -70 };

  public anchorAlign: Align = { horizontal: 'right', vertical: 'center' };
  public popupAlign: Align = { horizontal: 'right', vertical: 'center' };

  public get animate(): boolean | PopupAnimation {
    if (this.enabled) {
      return {
        type: this.type,
        direction: this.direction,
        duration: this.duration,
      };
    }
    return false;
  }
  public defaultItem: any = {
    id: 3,
    userRole: 'Engagement User',
  };

  public userRequestRoleTypes: UserRequestRoleType[] = [];

  public isSearchSelected: boolean = true;
  public searchText: string = '';
  public userProfile: any;
  public engagementDetails: any[] = [];
  public userDetails: any[] = [];
  public searchedEngagementDetails: any[] = [];
  public searchedUserDetails: any[] = [];
  public selectedEngagement: any = null;
  public selectedUser: any = null;
  public loggedInUserRole: string = '';
  public engagementApproverDetail: any[] = [];
  public isAutoApprove: boolean = false;
  public user: any;
  public isDataLoading: boolean = false;
  public isDisplayloader: boolean = false;
  public isDisplayloaderUserSearch: boolean = false;
  private searchUserSubject = new Subject<string>();

  private readonly popupService = inject(PopupService);
  private readonly clientService = inject(ClientService);
  private readonly engagementService = inject(EngagementService);
  private readonly userService = inject(UserService);
  private readonly userrequestService = inject(UserrequestService);
  private readonly authService = inject(AuthService);
  private readonly authUserService = inject(AuthUserService);
  private readonly router = inject(Router);
  private readonly fb = inject(FormBuilder);
  private readonly shownotificationService = inject(ShownotificationService);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private spinner = inject(NgxSpinnerService);

  constructor() {
    // Set up the subscriber to handle search requests with debouncing
    this.searchUserSubject.pipe(
      debounceTime(this.DEBOUNCE_TIME) // Adjust the debounce time as needed
    ).subscribe((value: string) => {
      this.executeUserSearch(value);
    });
  }

  ngOnInit(): void {
    if (this.isEngagementAccessRequired) {
      this.margin = { horizontal: -100, vertical: -130 };
    }

    if (!localStorage.getItem('loggedInUserRole')) {
      this.authUserService.loggedInUserProfile.subscribe((userRole) => {
        this.loggedInUserRole = userRole;
      });
    } else
      this.loggedInUserRole = localStorage.getItem('loggedInUserRole') ?? '';

    const clientId = sessionStorage.getItem('clientId');
    this.userProfile = JSON.parse(localStorage.getItem('userProfile') ?? '');
    if (this.isEngagementAccessRequired)
      this.searchUserDetailsListsByADObjectId(this.userProfile.id);
    this.createUserRequestDetailsForm();

    this.isDisplayloader = true;
    this.spinner.show();
    //for Auto Approve User
    if (this.loggedInUserRole === Roles.EngagementApproverUserRole) {
      const engagementId = sessionStorage.getItem('engagementId');
      this.getEngagementApproverDetail(engagementId);
    }
    this.getEngagementDetailsLists(clientId);


  }

  public open(): void {
    this.openUserRequestPopup = true;
    this.resetUserRequestDetailsForm();
  }

  // Get  Engagement
  public getEngagementDetailsLists(clientId: any): void {
    this.isSearchSelected = true;
    this.clientService
      .getClientEngagementsWithDetails(clientId)
      .subscribe((x) => {
        this.engagementDetails = x.data;
        this.searchedEngagementDetails = this.engagementDetails;
        const engagementId = sessionStorage.getItem('engagementId');
        if (engagementId) {
          this.selectedEngagement =
            this.searchedEngagementDetails.find(
              (engagement) => engagement.engagementId === +engagementId
            ) || null;
        }
        //load user Role Types
        this.getUserRequestRoleType();
      });
  }

  public getUserRequestRoleType(): void {
    this.userrequestService.getUserRequestRoleType().subscribe((x) => {
      this.userRequestRoleTypes = x.data;
      this.setUserRequestDetailsForm();
      this.isDisplayloader = false;
      this.spinner.hide();
    });
  }

  // Get  Engagement Approvers
  public getEngagementApproverDetail(engagementId: any): void {
    this.engagementService
      .getEngagementsApproverDetails(engagementId)
      .subscribe((x) => {
        this.engagementApproverDetail = x.data;

        // Check the details and find the index
        const foundIndex = this.engagementApproverDetail.findIndex((item) => {
          return (
            item.userId.toLowerCase() === this.userProfile.id.toLowerCase()
          );
        });

        this.isAutoApprove = foundIndex >= 0 ? true : false;
      });
  }

  public close(): void {
    this.openUserRequestPopup = false;
    this.closeEvent.emit();
    this.resetUserRequestDetailsForm();
    this.isSearchSelected = true;
    this.searchText = '';
    this.isAutoApprove = false;
  }

  // Search  Engagement
  public searchEngagementDetailsListsByEngagementName(value: any): void {
    this.searchText = value;
    if (value.length >= 3) {
      this.isSearchSelected = true;
      this.searchedEngagementDetails = this.engagementDetails.filter(
        (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
      );
    }
  }

  // Search  User in Digital Matrix
  // Modify your existing method to push values to the subject
  public searchUserDetailsListsByUserName(value: any): void {
    this.searchUserSubject.next(value);
  }

  // Extract the API call logic into a separate method
  private executeUserSearch(value: string): void {
    this.searchText = value;
    this.isSearchSelected = true;
    this.isDisplayloaderUserSearch = true;
    const searchUser = { searchString: value, pageSize: 10, nextPageToken: '' };

    this.userrequestService
      .searchUserDetailsListsByUserName(searchUser)
      .subscribe({
        next: (x) => {
          this.searchedUserDetails = x.users;
          this.isDataLoading = true;
          this.isDisplayloaderUserSearch = false;
        },
        error: () => {
          this.isDisplayloaderUserSearch = false;
        }
      });
  }

  public searchUserDetailsListsByADObjectId(value: any): void {
    this.searchText = value;
    this.isSearchSelected = true;
    this.userrequestService
      .searchUserDetailsListsByADObjectId(this.searchText)
      .subscribe((x) => {
        this.searchedUserDetails = [x];
        this.isDataLoading = true;
      });
  }

  public onSelectedEngagement(engagementName: string) {
    this.selectedEngagement = engagementName;
    let searchedEngagement = this.searchedEngagementDetails.find(
      (e) => e.engagementName === this.selectedEngagement
    );
    this.searchText = searchedEngagement.engagementName;
  }

  public onSelectedUser(emailAddress: string) {
    this.selectedUser = emailAddress;
    let searchedUser = this.searchedEngagementDetails.find(
      (e) => e.emailAddress === this.selectedUser
    );
    this.searchText =
      searchedUser.firstName +
      ' ' +
      searchedUser.lastName +
      ' ' +
      '-' +
      searchedUser.emailAddress;
  }

  public setUserRequestDetailsForm(): void {
    if (this.isEngagementAccessRequired)
      this.user = {
        id: this.userProfile.id,
        displayName: this.userProfile.firstName,
        emailAddress: this.userProfile.email,
      };

    this.userRequestDetailsForm.setValue({
      engagementDetail: this.selectedEngagement,
      userDetail: this.isEngagementAccessRequired ? this.user : null,
      userRoleDetail: this.userRequestRoleTypes[0],
      RequestUserId: this.userProfile.id,
      RequestUserEmail: this.userProfile.email,
      ApprovalUserId: this.isAutoApprove ? this.userProfile.id : null,
      ApprovalUserEmail: this.isAutoApprove ? this.userProfile.email : null,
    });

    if (this.isEngagementAccessRequired) {
      this.userRequestDetailsForm.get('userDetail')?.disable();
      this.userRequestDetailsForm.get('engagementDetail')?.disable();
    }
  }

  public createUserRequestDetailsForm(): void {
    this.userRequestDetailsForm = this.fb.group({
      engagementDetail: [null, Validators.required],
      userDetail: [null, Validators.required],
      userRoleDetail: [null, Validators.required],
      RequestUserId: [null, Validators.required],
      RequestUserEmail: [null, Validators.required],
      ApprovalUserId: [null],
      ApprovalUserEmail: [null],
    });
  }

  public handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      this.close();
    }
  };

  public resetUserRequestDetailsForm(): void {
    this.setUserRequestDetailsForm();
  }

  public createUserRequestDetails(): void {
    // if(this.isEngagementAccessRequired)
    //    this.userRequestDetailsForm.patchValue({userDetail:this.searchedUserDetails.find(x=>x.id.toLowerCase()===this.userProfile.id.toLowerCase())})

    if (this.userRequestDetailsForm.valid) {
      this.isDisplayloader = true;
      this.spinner.show();
      let userDetailValue =
        this.userRequestDetailsForm.get('userDetail')?.value;
      let userEmailValue =
        userDetailValue.accountType === 'CloudNative'
          ? userDetailValue.userPrincipalName
          : userDetailValue.emailAddress === null
            ? userDetailValue.alternateEmailAddress
            : userDetailValue.emailAddress;

      const userRequest: SaveUserRequestDetailRequest = {
        userRequestId: 0,
        requestId: 0,
        engagementId: this.userRequestDetailsForm.get('engagementDetail')?.value.engagementId,
        name: this.userRequestDetailsForm.get('userDetail')?.value.displayName,
        userId: this.userRequestDetailsForm.get('userDetail')?.value.id,
        userEmail: this.isEngagementAccessRequired
          ? this.userProfile.email
          : userEmailValue,
        RequestUserId: this.userProfile.id,
        RequestUserEmail: this.userProfile.email,
        RequestUserComment: 'User Addition Requested',
        ApprovalUserId: this.isAutoApprove ? this.userProfile.id : null,
        ApprovalUserEmail: this.isAutoApprove ? this.userProfile.email : null,
        ApprovalUserComment: null,
        // SupportUserId: null,
        SupportUserComment: null,
        userRequestRoleTypeId: this.userRequestDetailsForm.get('userRoleDetail')?.value.id, // Need to replace this
      };
      if (userRequest.userId && userRequest.engagementId) {
        this.userrequestService
          .createUserRequestDetails(userRequest, this.isAutoApprove)
          .subscribe({
            next: () => {
              if (this.isAutoApprove)
                this.shownotificationService.showNotification(
                  'autoApproveUserSuccess'
                );
              else
                this.shownotificationService.showNotification(
                  'successUsertRequest'
                );
              this.isDisplayloader = false;
              this.spinner.hide();
              this.close();
            },
            error: (error) => {
              var errorResult = JSON.parse(error.error);
              if (errorResult.StatusCode == '500') {
                this.shownotificationService.showNotification(
                  errorResult.StatusCode,
                  errorResult.StatusCode + ':Internal Server Error'
                );
              } else if (errorResult.StatusCode == '503') {
                this.shownotificationService.showNotification(
                  errorResult.StatusCode,
                  errorResult.StatusCode + ':Service Unavailable'
                );
              } else {
                this.shownotificationService.showNotification(
                  'userRequestAlreadyExistError',
                  errorResult.ErrorMessage
                );
                this.isDisplayloader = false;
                this.spinner.hide();
                this.close();
                //this.shownotificationService.showNotification('userRequestAlreadyExistError');
              }
            },
          });
      } else {
        this.isDisplayloader = false;
        this.spinner.hide();
        this.close();
        this.shownotificationService.showNotification('userRequestError');
      }
    }
  }

  public cancelUserRequestDetails(): void {
    this.close();
  }
}
